'use strict';

/** @type {import('./round')} */
module.exports = Math.round;



//////////////////
// WEBPACK FOOTER
// ../math-intrinsics/round.js
// module id = 694
// module chunks = 0